import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18/i18n';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueApexCharts from 'vue-apexcharts';
import { getCookie } from "./utils";
import store from './store';
import NotificationInit from './services/notifications';

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueApexCharts)
Vue.use(store);
Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false

//reinitialize and get all notification again after each reload and i user already logged in
const userId = getCookie("user_id");
if (userId) {
  store.dispatch('getNotifications');
}

new Vue({
  router,
  i18n,
  BootstrapVue,
  IconsPlugin,
  VueApexCharts,
  store,
  render: h => h(App),
}).$mount('#app')
